import React, { FC } from 'react'
import { useLayout } from '../core'

const Footer: FC = () => {
  const { classes } = useLayout()
  const year = new Date().getFullYear()
  return (
    <div className='footer py-4 d-flex flex-lg-column' id='kt_footer'>
      {/* begin::Container */}
      <div className={`${classes.footerContainer} d-flex flex-column flex-md-row flex-stack`}>
        {/* begin::Copyright */}
        <div className='text-dark order-2 order-md-1'>
          <span className='text-gray-400 fw-bold me-1'>Developed by</span>
          <a
            href='mailto:jas.enterprisesolutions@gmail.com'
            className='text-muted text-hover-primary fw-bold me-2 fs-6'
          >
            JAS, Enteprise Solutions &copy; 2022 - {year}
          </a>
        </div>
        {/* end::Copyright */}

        {/* begin::Menu */}
        <ul className='menu menu-gray-600 menu-hover-primary fw-bold order-1'>
          <li className='menu-item'>
            <a
              href='mailto:jas.enterprisesolutions@gmail.com?subject=Anomalia x'
              className='menu-link px-2'
            >
              Reportar Anomalia
            </a>
          </li>
          <li className='menu-item'>
            <a href='#' className='menu-link px-2'></a>
          </li>
        </ul>
        {/* end::Menu */}
      </div>
      {/* end::Container */}
    </div>
  )
}

export { Footer }
